import React, { useState, useCallback } from 'react';

import { Button, Textarea } from '@ontruck/orc';
import DriverSelect from './DriverSelect';
import { injectIntl } from 'react-intl';

const CustomAssignment = ({ className, onAssign, route, intl }) => {
  const t = intl.messages.modules.dispatching.assignment.custom;
  const [driver, setDriver] = useState(null);
  const [reason, setReason] = useState('');

  const handleChange = useCallback((driverToAssign) => {
    setDriver(driverToAssign);
  }, []);

  const handleChangeComment = useCallback(
    (_, { value }) => {
      setReason(value);
    },
    [setReason]
  );

  const handleAssignment = useCallback(() => {
    onAssign &&
      onAssign({
        driverId: driver?.id,
        assignmentReason: reason || '',
      });
  }, [driver, onAssign, reason]);

  const isButtonDisabled = !driver;

  return (
    <div className={className}>
      <div className="form-control">
        <div className="placeholder">{t.placeholder_driver}</div>
        <DriverSelect
          onChange={handleChange}
          route={route}
          name="driver_select"
          inputId="driver_select"
          autoFocus={false}
        />
      </div>
      <div className="form-control">
        <div className="placeholder">{t.placeholder_reason}</div>
        <div className="textarea" data-testid="textarea">
          <Textarea value={reason} label={t.label_reason} onChange={handleChangeComment} />
        </div>
      </div>
      <Button fullWidth className="button" onClick={handleAssignment} disabled={isButtonDisabled}>
        {t.assign_button}
      </Button>
    </div>
  );
};

export default injectIntl(CustomAssignment);
